export const STATUS_COLORS = {
  Open: "usp",
  "On the way": "usp",
  Started: "usp",
  Completed: "positive",
  Failed: "negative",
} as const;
